import DeleteFolderPopUp from "./DeleteFolderPopUp";

export default DeleteFolderPopUp;
